import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
const StyledClickableRow = styled('tr', {
    cursor: 'pointer',
    ':hover': {
        backgroundColor: staticColors.dynamicTableRowHover,
    },
});
export const DynamicTableRow = ({ children, isClickable, }) => {
    if (isClickable)
        return _jsx(StyledClickableRow, { children: children });
    return _jsx("tr", { children: children });
};
